import React, { FC } from 'react'
import { Heading } from '@moonpig/launchpad-components'
import { useProductContext } from '../../../contexts/product'
import { ProductModule } from '../types'
import { ProductModuleSection } from '../ProductModuleSection'

export const ProductTitleModule: FC<ProductModule> = props => {
  const [
    {
      product: { title },
    },
  ] = useProductContext()

  return (
    <ProductModuleSection
      {...props}
      data-testid="loyalty-product-module-section"
    >
      <Heading
        level="h1"
        typography={{ xs: 'typeMobileDisplay01', lg: 'typeDesktopDisplay04' }}
        mb={0}
      >
        {title}
      </Heading>
    </ProductModuleSection>
  )
}
